import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['table', 'show', 'hide'];

  show() {
    this.showTarget.classList.add('is-hidden');
    this.tableTarget.classList.remove('is-hidden');
    this.hideTarget.classList.remove('is-hidden');
  }

  hide() {
    this.showTarget.classList.remove('is-hidden');
    this.tableTarget.classList.add('is-hidden');
    this.hideTarget.classList.add('is-hidden');
  }
}
